
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M33.04 24.25H6.96l-2.6-4.5h31.28l-2.6 4.5zM14.99 9.7l-2.81-4.78h15.64L25.01 9.7"}}),_c('path',{attrs:{"d":"M25.54 40v-3.66c0-2.09 2.45-12.2 2.45-12.2M14.46 40v-3.66c0-2.09-2.45-12.2-2.45-12.2M7.27 19.94L1.5 13.68l1.8-4.24s33.31-.12 33.4 0l1.8 4.24-5.77 6.26M2.46 13.91h35.08M20 24.52V40M20 0v5","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    